(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-benefit-slider"] && !Shopify.designMode) return;
  try {
    
let swiperItems = document.querySelectorAll('.swiper-slide'); 
  var swiper = new Swiper(".benefitSwiper", {
    loop: true,  
    slidesPerView: 1,
    autoplay: {
      delay: 3000,
    }
  });

  } catch(e) { console.error(e); }
})();
})();
